

































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateBhusers from "./create-bhusers.vue";
import EditBhusers from './edit-bhusers.vue';
import EditIntegral from './edit-Integral.vue';
let ispartysrc= require("@/images/danghui.png");

class PageBHUserRequest extends PageRequest {
  Keyword: string;
  isrent: number; //nullable
  stime: Date;
  etime: Date;
  uzhuang:string;
  udanyuan:string;
  ushi:string;
  Disid:number; //区域ID
  Streetid:number;//街道ID
  Comid:number;//社区ID
  Vid:number;//小区ID

}

 @Component({
        components:{CreateBhusers,EditBhusers,EditIntegral}
    })
export default class BHUsers extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  editIntegral() {
    this.editModalIntegralShow = true;
  }
  //filters
  pagerequest: PageBHUserRequest = new PageBHUserRequest();
  creationTime: Date[] = [];

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  editModalIntegralShow: boolean = false;
  get list() {
    return this.$store.state.bhusers.list;
  }
  get loading() {
    return this.$store.state.bhusers.loading;
  }
   
    //获取初始值
    get qarealist(){
 
            return this.$store.state.bhusers.qarea;
     }
      //区下面的街道
       get qarealst(){
           return this.$store.state.bhusers.qarealst;
       }
       set qarealst(val:number){
            this.$store.commit('bhusers/change_qarealst',val);
       }
       //街道的社区
       get sarealst(){
            return this.$store.state.bhusers.sarealst;
       }
       set sarealst(val:number){
          this.$store.commit('bhusers/change_sarealst',val);           
        
       }
       //社区下的小区
      get carealst(){

            return this.$store.state.bhusers.carealst;
       }
       set carealst(val:number){
          this.$store.commit('bhusers/change_carealst',val);           
        
       }
       
     QAreaChange(val:number){
        
       this.pagerequest.Disid=val;
        
     var dt= this.$store.state.bhusers.qarea;
        dt.forEach(item=>{
        if(item.id==val){
         this.qarealst=item;
            }
          })

       }
      SAreaChange(val:number){
       this.pagerequest.Streetid=val;
       var dt= this.$store.state.bhusers.qarealst.sAreas;
     dt.forEach(item=>{
        if(item.id==val){
         this.sarealst=item;
        }
    })
      }
     CAreaChange(val:number){
         this.pagerequest.Comid=val;
       var dt= this.$store.state.bhusers.sarealst.cAreas;
    dt.forEach(item=>{
    if(item.id==val){
         this.carealst=item;
        }
    })
   }
   VAreaChange(val:number){
         this.pagerequest.Vid=val;
        
   }

  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("bhusers/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("bhusers/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    if (this.creationTime.length > 0) {
      this.pagerequest.stime = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.etime = this.creationTime[1];
    }

    await this.$store.dispatch({
      type: "bhusers/getAll",
      data: this.pagerequest,
    });
  }
  async getAreaAll() {
    await this.$store.dispatch({
      type: "bhusers/getQAreaAllData",
    });
  }

  isIsrentChange(val: string) {
    if (val === "Yes") {
      this.pagerequest.isrent = 1;
    } else if (val === "No") {
      this.pagerequest.isrent = 0;
    } else {
      this.pagerequest.isrent = null;
    }
  }

  get pageSize() {
    return this.$store.state.bhusers.pageSize;
  }
  get totalCount() {
    return this.$store.state.bhusers.totalCount;
  }
  get currentPage() {
    return this.$store.state.bhusers.currentPage;
  }
   
 
  columns = [
    {
      
      title: this.L("CustomerName"),
      key: "username",

      render: (h: any, params: any) => {

           if(params.row.isParty==1){
                return h("div", [
          h( "span",params.row.username),
       

          h("el-image", {
          props: {
            src: ispartysrc,
          //  "preview-src-list": [ispartysrc],
          },
          style: {
            height: "20px",
            float:'right'
          },
           
        })
         ])
            
            }else{
           return h("div", [
          h( "span",params.row.username)

         ])
       }

       

      }
     

     
    },

     

    {
      title: this.L("VilName"),
      render: (h: any, params: any) => {
        return h("span", params.row.vArea.vilname);
      },
    },
     
    {
      
      title: this.L("Qrcode"),
      key: "qrcode",
    },
    {
      
      title: this.L("IntegralCard"),
      key: "integralCard",
    },
    {
     
      title: this.L("OtherCard"),
      key: "otherCard",
    },
    {
      title: this.L("Useraddr"),
      key: "useraddr",
    },
    
    {
    
      title: this.L("Isrent"),
      render: (h: any, params: any) => {
        return h("span", params.row.isrent ? this.L("Yes") : this.L("No"));
      },
    },
    {
    
      title: this.L("BJifen"),
      key: "bJifen",
    },
    {
     
      title: this.L("GJifen"),
      key: "gJifen",
    },
     
    {
      title: this.L("Addtime"),
      key: "addtime",
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.addtime).toLocaleString());
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 190,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "2px",
              },
              on: {
                click: () => {
                
                  this.$store.commit("bhusers/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          
          h(
            "Button",
            {
              props: {
                type: "info",
                size: "small",
              },
              style: {
                marginRight: "2px",
              },
              on: {
                click: () => {
                
                  this.$store.commit("bhusers/edit", params.row);
                  this.editIntegral();
                },
              },
            },
            this.L("积分操作")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteUserConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "bhusers/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
    this.getAreaAll();
  }
  //导出
   async  exportExcel() {
   
     this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "bhusers/getAllexportExcel",
      data: this.pagerequest,
    });
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
				
					lt.map((item) => { // 这里修改要下载的字段内容
					  item.isrent == 0 ? item.isrent = '否' : item.isrent == 1 ?  item.isrent ='是' : item.isrent ='否'
            item.isParty == 0 ? item.isParty = '否' : item.isParty == 1 ?  item.isParty ='是' : item.isParty ='否'
            item.vilname='';
           if(item.vArea!=null){
            item.vilname=item.vArea.vilname;
           }
            item.addtime=new Date(item.addtime).toLocaleString()
					  return item;
					});
    
					const filterVal = ['id', 'username','isrent' ,'vilname', 'qrcode', 'integralCard', 'otherCard', 'useraddr','phone','isrent','bJifen','gJifen','addtime'];// 取出要下载的表头字段
					const tHeader = ['编号','用户姓名','是否是党员','小区','易腐垃圾卡号','积分卡','其他垃圾卡','地址','联系方式','是否为租户','可回收积分(蓝)','易腐垃圾积分(绿)','创建时间'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '会员中心');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}

   
			
}
